var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ib-col", [
    _vm.selectedTab === "companies"
      ? _c("div", [
          _vm.groupAssets === "all"
            ? _c("div", [_c("SearchResultsCompanies")], 1)
            : _vm.prevAsset === "etfs"
            ? _c("div", [_c("SearchResultsCompanies")], 1)
            : _vm.prevAsset === "stocks"
            ? _c("div", [_c("SearchResultsGroups")], 1)
            : _vm._e(),
        ])
      : _c(
          "div",
          [
            _c("FilterOptions", { on: { update: _vm.search } }),
            _vm.prevAsset === "all"
              ? _c("div", [_c("SearchResultsCombined")], 1)
              : _vm.prevAsset === "etfs"
              ? _c("div", [_c("SearchResultsETFs")], 1)
              : _vm.prevAsset === "stocks"
              ? _c("div", [_c("SearchResults")], 1)
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }